export enum CrudStoreItemHpScout {
  WW_REF_ID = 'WW_REF_ID',
  PartnerRefIDs = 'PartnerRefIDs',
  PartnerRefIDsRequests = 'PartnerRefIDsRequests',

  CDPReportM01 = 'M01',
  SustainabilityReportM02 = 'M02',
  GHGInventoryM03 = 'M03',
  CDPReportDisclosureM04 = 'M04',
  CarbonReductionRoadmapM05 = 'M05',
  ReductionOfCarbonEmissionM06 = 'M06',
  CorporateRoadmapM07 = 'M07',
  GHGGoalsM08 = 'M08',
  CircularEconomyPrinciplesM09 = 'M09',
  LanetPartnerM10 = 'M10',
  ConductTrainingM11 = 'M11',
  HpLifeM12 = 'M12',
  HpLifeCommunityM13 = 'M13',
  DEIGoalsM14 = 'M14',
  SpendAMinimum10PercM15 = 'M15',
  SustainabilityCampaignM16 = 'M16',
  SupplierEngageM17 = 'M17',
  SupplierParticipationIntoResearchM18 = 'M18',

  CSHubManagement = 'CSHubManagement',
  CSHubManagementItems = 'CSHubManagementItems',
  CSHubPartnerScores = 'CSHubPartnerScores',
  CSHubPartnerScoresItem = 'CSHubPartnerScoresItem',
  CSPartnerInfo = 'CSPartnerInfo',
  CSContactInfo = 'CSContactInfo',

  RecentSearches = 'RecentSearches',
  ACHolidays = 'ACHolidays',
  ACSettings = 'ACSettings',
}
